import React, {
  ComponentType,
  useState
} from 'react'
import {
  Dropdown,
  Responsive
} from 'semantic-ui-react'

const SafeResponsive = Responsive as unknown as ComponentType<any>
const SafeDropdown = Dropdown as unknown as ComponentType<any>

type PotentialCountSelectProps = {
  onChange?: (
    event: React.SyntheticEvent,
    data: {
      name: string
      value: string | string[]
    }
  ) => void
  name?: string
  value?: string | string[]
  placeholder?: string
  multiple?: boolean
}

/**
 * Provides a stand-alone select widget that allows you to select 1, 2, 3, 4+
 * potential condition counts.
 * @param onChange Callback function on potential count select
 *   Arguments: (e, {name, value}) where value is the potential count
 *    or "" if the ALL option is selected
 * @param name Name of the select widget in a form context. Default:
 *   potentialCountSelect
 * @param value Initial selected potential count
 * @param placeholder Placeholder text. Default: Potential Opportunities
 * @param multiple Allow multiple selections. Default: true
 */
function PotentialCountSelect(props: PotentialCountSelectProps): JSX.Element {
  const {
    onChange: onChangeProp,
    name: nameProp,
    value: valueProp,
    placeholder: placeholderProp,
    multiple: hasMultipleProp
  } = props

  const [ potentialCounts ] = useState<string[]>([
    '1 Potential Opportunity',
    '2 Potential Opportunities',
    '3 Potential Opportunities',
    '4+ Potential Opportunities'
  ])

  const isMultiple = hasMultipleProp !== false

  const handleChange = (
    event: React.SyntheticEvent,
    data: {
      value: string | string[]
    }
  ) => {
    if (onChangeProp) {
      const name = nameProp || 'potentialConditionCount'
      onChangeProp(
        event,
        {
          name,
          value: data.value
        }
      )
    }
  }

  const options = potentialCounts.map(element => ({
    key: element,
    value: element.replaceAll(/[^+\d]/g, ''),
    text: element,
    id: `${element.substring(0, 1)}-potential-opp`
  }))

  const placeholder = placeholderProp || 'Potential Opportunities'
  const id = 'potential-count-select'

  if (isMultiple === true) {
    const value = valueProp || []
    return (
      <SafeResponsive
        as={ SafeDropdown }
        id={ id }
        fluid
        multiple
        selection
        placeholder={ placeholder }
        onChange={ handleChange }
        options={ options }
        value={ value }
      />
    )
  }

  const value = valueProp || undefined
  return (
    <SafeResponsive
      as={ SafeDropdown }
      id={ id }
      fluid
      selection
      placeholder={ placeholder }
      onChange={ handleChange }
      options={ options }
      value={ value }
    />
  )
}

export default PotentialCountSelect
